function upReview(delay = 8000) {
  setTimeout(() => {
  const elts= document.querySelectorAll('.jdgm-rev.jdgm-divider-top.jdgm--done-setup');
  elts.forEach((element) => {
    if (element.getAttribute('data-verified-buyer') === 'false') {
   
      element.setAttribute('data-verified-buyer', 'true');
      const aw = element.querySelector('.jdgm-rev__author-wrapper');
      
      if (aw) {
        const badgeWrapper = document.createElement('span');
        badgeWrapper.className = 'jdgm-rev__buyer-badge-wrapper';
        const badge = document.createElement('span');
        badge.className = 'jdgm-rev__buyer-badge';
        badgeWrapper.appendChild(badge);
        aw.appendChild(badgeWrapper);
      }
    }
  });

  
  }, delay); 
}

document.addEventListener('click', (event) => {
  const lmb = event.target.closest('.jdgm-btn.jdgm-btn--solid.jdgm-paginate__load-more');
  if (lmb) {
    upReview(1500);
  }
});


upReview();